import { IEntity } from "@interfaces/entity";
import { Type } from "class-transformer";
import { ChargingStation } from "./charging-station";
import { Customer } from "./customer";
import { User } from "./identity/user";
import { Tag } from "./tag";

export class RfidCard implements IEntity {
  id: number;
  idTag: string;

  userId: string;
  user: User;

  customerId: number;
  customer: Customer;

  lastAuthorizationDate: Date;

  lastUsedChargingStationId: string;
  lastUsedChargingStation: ChargingStation;

  note: string;
  tags: Tag[];

  entityName = "RfidCard";

  constructor(formValue?: Partial<RfidCard>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<RfidCard>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
